import { render, staticRenderFns } from "./PatientTile.vue?vue&type=template&id=1884b999"
import script from "./PatientTile.vue?vue&type=script&lang=ts"
export * from "./PatientTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports